const devValue = (value) =>
  process.env.NODE_ENV === "development" ? value : "";

export default devValue;
